module.exports = __webpack_public_path__ + "static/media/AptAutobook.e570ccca.svg";